export default "__VITE_ASSET__xBfOp7hc__"